const ACTION_BY_OPERATION_ID = {
  inventory: "kiểm kê",
  transfer: "điều chuyển",
  return: "trả hủy",
};

export const getTrungThuSubmitConfirmationMessage = (operationId, cakeType) => {
  if (operationId === "sale") {
    return `Bạn có muốn bán (${cakeType}) các bánh trên ?`;
  }

  const action = ACTION_BY_OPERATION_ID[operationId] || "thực hiện nghiệp vụ với";
  return `Bạn có muốn ${action} các bánh trên ?`;
};
